var PaginationLoaded = false;

function paginateListBlock(blockId) {
  var resultblocks = document.querySelectorAll('.js-results[data-block-id]');

  for (var i = 0; i < resultblocks.length; i++) {
    var thisBlock = resultblocks[i];

    if (blockId && thisBlock.dataset.blockId !== blockId) {
      continue;
    }

    var links = thisBlock.querySelectorAll('.pagination li a');
    for (var j = 0; j < links.length; j++) {
      var link = links[j];
      link.addEventListener('click', function (event) {
        event.preventDefault();

        var block = this.parentElement;
        while (!block.classList.contains('js-results')) {
          block = block.parentElement;
        }

        var page = this.href.split('p=')[1] || 0;
        if (isNaN(page)) {
          page = 0;
        }

        var request = new XMLHttpRequest();
        var url = '/PageListApi/LoadNextPage?p=' + page + "&blockId=" + block.dataset.blockId;
        if (block.dataset.display) {
          url += '&display=' + block.dataset.display;
        }

        this.parentNode.classList.add('js-spinner');

        request.open('GET', url);
        request.onload = function () {
          var response = this;
          if (response.status === 200) {
            block.innerHTML = response.responseText;
            block.scrollIntoView();
            paginateListBlock(block.dataset.blockId);
          }
          else {
            this.parentNode.classList.remove('js-spinner');
            throw "Error loading next page";
          }
        };
        request.send();
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (PaginationLoaded === false) {
    paginateListBlock();
    PaginationLoaded = true;
  }
});
